import type { TFunction } from "i18next";

import { ApiError } from "../api/client";

/** Map a backend antenna-related error code to a localized message. */
export function antennaErrorMessage(err: unknown, t: TFunction): string | null {
  const code =
    err instanceof ApiError && err.detail && typeof err.detail === "object"
      ? (err.detail as { error?: unknown }).error
      : null;
  if (typeof code === "string" && ["batch_not_antenna", "invalid_link", "antenna_type_inactive", "invalid_product_type", "text_required", "parse_failed"].includes(code)) {
    return t(`antennas.errors.${code}`);
  }
  return null;
}
